/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button, Select } from 'antd';
import { LayoutForm } from './flota'
import { Label } from '../../views/contactanos/contactanos';
import { useCategoriasSeccion, useSubcategoriaCategoria, useModelosCotizar, useModeloSlug } from '../../../hooks/Front/formularios/useFormularios';
import { checkIsNotEmpty } from '../../../helper/validations';
import { errorSwal } from '../../../helper/swalHelpers';
import { useParams } from 'react-router';

const Vehiculo = ({ states }) => {
    const { slug, slugversion } = useParams();
    const { vehiculo: vehiculoSlug, error: errorSlug, loading: loadingSlug } = useModeloSlug(slug);

    const [form, setForm] = useState({
        idCategoria: undefined,
        idSubcategoria: undefined,
        idModelo: undefined,
        idVersion: undefined,
        cantidad: 1,
        tipo: 'vehiculo'
    })

    const [isBus, setIsBus] = useState(false);
    const [producto, setProducto] = useState(undefined);
    const [version, setVersion] = useState(undefined);

    const [filtro, setFiltro] = useState({
        Modulo: 'MODELOS',
        idCategoria: undefined,
        NumeroDePasajerosValorMax: "",
        NumeroDePasajerosValorMin: ""
    });

    const { idCategoria, idSubcategoria, idModelo, cantidad, idVersion } = form;

    const handleChange = (name, value) => {
        if (name === 'idCategoria') {
            setForm({ ...form, [name]: value, idSubcategoria: undefined, idModelo: undefined, idVersion: undefined, restricciones: [] });
            states.setProducto(undefined);
            setProducto(undefined);
            setVersion(undefined);
            if (value === 4) {
                setIsBus(true);
                return;
            }
            setIsBus(false);
            return;
        }
        if (name === 'idSubcategoria') {
            setForm({ ...form, [name]: value, idModelo: undefined, idVersion: undefined, restricciones: [] });
            setFiltro({ ...filtro, idCategoria: value, NumeroDePasajerosValorMax: "", NumeroDePasajerosValorMin: "" });
            setProducto(undefined);
            setVersion(undefined);
            states.setProducto(undefined);
            return;
        }
        if (name === 'idModelo') {
            let iModelo = modelos.findIndex(v => v.idVehiculo === value);
            const modelo = modelos[iModelo];
            setProducto(modelo);

            states.setProducto({ ...modelo, tipo: "vehiculo", cantidad });
            if (modelo.versiones && modelo.versiones.length < 1) {
                setForm({ ...form, [name]: value, idVersion: modelo.idVersion, versiones: [], restricciones: modelo.restricciones });
                return;
            }
            setForm({ ...form, [name]: value, idVersion: undefined, versiones: modelo.versiones, restricciones: modelo.restricciones});
        }
    }

    const changePasajeros = (value) => {
        setProducto(undefined);
        states.setProducto(undefined);
        if (value === 16) {
            setFiltro({ idCategoria: 4, NumeroDePasajerosValorMin: 1, NumeroDePasajerosValorMax: value });
            setForm({ ...form, idSubcategoria: 4, NumeroDePasajerosValorMax: value });
        }
        else if (value === 33) {
            setFiltro({ idCategoria: 4, NumeroDePasajerosValorMin: 17, NumeroDePasajerosValorMax: value });
            setForm({ ...form, idSubcategoria: 4, NumeroDePasajerosValorMax: value });
        }
        else {
            setFiltro({ idCategoria: 4, NumeroDePasajerosValorMin: 34, NumeroDePasajerosValorMax: value });
            setForm({ ...form, idSubcategoria: 4, NumeroDePasajerosValorMax: value });
        }
    }

    const handleChangeRestar = () => {
        if (cantidad >= 2) {
            let newCantidad = cantidad - 1;
            setForm({ ...form, cantidad: newCantidad });
            if (producto && idVersion && !version) states.setProducto({ ...producto, tipo: 'vehiculo', cantidad: newCantidad });
            if (producto && idVersion && version) states.setProducto({ ...version, tipo: 'vehiculo', cantidad: newCantidad });
        }
    }

    const handleChangeSumar = () => {
        if (cantidad < 10) {
            let newCantidad = cantidad + 1;
            setForm({ ...form, cantidad: newCantidad });
            if (producto && idVersion && !version) states.setProducto({ ...producto, tipo: 'vehiculo', cantidad: newCantidad });
            if (producto && idVersion && version) states.setProducto({ ...version, tipo: 'vehiculo', cantidad: newCantidad });
        }
    };

    const handleChangeVersion = (value) => {
        const iVersion = producto.versiones.findIndex(v => v.idVersion === value)
        const version = producto.versiones[iVersion];
        version.tipoMoneda = producto.tipoMoneda ? producto.tipoMoneda : "CLP";
        version.restricciones = producto.restricciones ?? [];
        states.setProducto({ ...version, tipo: 'vehiculo', cantidad,  });
        setVersion(version);
        setForm({ ...form, idVersion: value });
    }

    const validateForm = () => {
        if (!checkIsNotEmpty(idCategoria) ||
            !checkIsNotEmpty(idSubcategoria) ||
            !checkIsNotEmpty(idModelo) ||
            !checkIsNotEmpty(idVersion)) {
            return false;
        }
        return true;
    }

    const handleClick = () => {
        if (!validateForm()) {
            errorSwal("Ocurrió un error", "Recuerda ingresar todos los campos requeridos.", "Ok");
            return;
        }
        states.setFormP(form);
        states.setPaso(1);
    }

    const { categorias, loading: loadingM, error: errorM } = useCategoriasSeccion("MODELOS");
    const { subcategorias, loading: loadingS, error: errorS } = useSubcategoriaCategoria(idCategoria);
    const { modelos, loading: loadingMo, error: errorMo } = useModelosCotizar(filtro)


    useEffect(() => {
        if (slug && vehiculoSlug && errorSlug === false && loadingSlug === false) {
            if (states.producto) {
                setFiltro({ ...filtro, idCategoria: states.formProducto.idSubcategoria, NumeroDePasajerosValorMax: "", NumeroDePasajerosValorMin: "" });
                setProducto({ ...states.producto, versiones: states.formProducto.versiones, restricciones: states.formProducto.restricciones })
                setForm({ ...form, idCategoria: states.formProducto.idCategoria, idSubcategoria: states.formProducto.idSubcategoria, idModelo: states.formProducto.idModelo, idVersion: states.formProducto.idVersion, versiones: states.formProducto.versiones, restricciones: states.formProducto.restricciones });
                return;
            }
            let versiones = vehiculoSlug.Versiones ? vehiculoSlug.Versiones : []
            let dataV = { ...vehiculoSlug.Vehiculo, versiones: versiones, restricciones: vehiculoSlug.Restricciones }
            setFiltro({ ...filtro, idCategoria: dataV.idSubCategoria, NumeroDePasajerosValorMax: "", NumeroDePasajerosValorMin: "" });
            setProducto(dataV);
            if (versiones.length < 1) {
                setForm({ ...form, idCategoria: dataV.idCategoria, idSubcategoria: dataV.idSubCategoria, idModelo: dataV.idVehiculo, idVersion: dataV.idVersion, versiones: [], restricciones: vehiculoSlug.Restricciones });
                states.setProducto({ ...dataV, tipo: 'vehiculo', cantidad, versiones: versiones, restricciones: vehiculoSlug.Restricciones });
                return;
            }
            let version = slugversion ? versiones.find((item) => item.idVersionCRM === slugversion) : undefined
            setForm({ ...form, idCategoria: dataV.idCategoria, idSubcategoria: dataV.idSubCategoria, idModelo: dataV.idVehiculo, idVersion: (version && version.idVersion) ? version.idVersion : undefined, versiones: versiones, restricciones: vehiculoSlug.Restricciones });
            states.setProducto({ ...dataV, tipo: 'vehiculo', cantidad, versiones: versiones, restricciones: vehiculoSlug.Restricciones });
        }

    }, [vehiculoSlug, errorSlug, loadingSlug, slug])

    useEffect(() => {
        if (states.producto) {
            setFiltro({ ...filtro, idCategoria: states.formProducto.idSubcategoria, NumeroDePasajerosValorMax: "", NumeroDePasajerosValorMin: "" });
            setProducto({ ...states.producto, versiones: states.formProducto.versiones, restricciones: states.formProducto.restricciones })
            setForm({ ...form, idCategoria: states.formProducto.idCategoria, idSubcategoria: states.formProducto.idSubcategoria, idModelo: states.formProducto.idModelo, idVersion: states.formProducto.idVersion, versiones: states.formProducto.versiones, restricciones: states.formProducto.restricciones });
            return;
        }
    }, [])


    useEffect(() => {
        if (slugversion && slug && vehiculoSlug && form.idCategoria && form.idSubcategoria && form.idModelo && form.idVersion) {
            const iVersion = vehiculoSlug.Versiones.findIndex(v => v.idVersion === form.idVersion)
            const version = vehiculoSlug.Versiones[iVersion];
            version.tipoMoneda = vehiculoSlug.tipoMoneda ? vehiculoSlug.tipoMoneda : "CLP";
            states.setProducto({ ...version, tipo: 'vehiculo', cantidad, versiones: vehiculoSlug.Versiones, restricciones: vehiculoSlug.Restricciones });
            setVersion(version);
            handleClick()
        }

        if (states.formProducto?.NumeroDePasajerosValorMax)
            setFiltro({
                idCategoria: states.formProducto.idCategoria,
                NumeroDePasajerosValorMax: states.formProducto.NumeroDePasajerosValorMax
            });

        getViewPortWidth()
    }, [form])

    const handleContinue = () => {
        if (!validateForm()) {
            errorSwal("Ocurrió un error", "Recuerda ingresar todos los campos requeridos.", "Ok");
            return;
        }

        states.setFormP(form);
        // if (producto) states.setProducto({ ...producto, tipo: "vehiculo", cantidad })

        states.setPaso(1);
    }

    const getViewPortWidth = () => {
        let viewportwidth;
        // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
        if (typeof window.innerWidth != 'undefined') {
            viewportwidth = window.innerWidth;
            // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
        } else
            if (typeof document.documentElement != 'undefined' &&
                typeof document.documentElement.clientWidth != 'undefined' &&
                document.documentElement.clientWidth != 0) {
                viewportwidth = document.documentElement.clientWidth;
                // older versions of IE
            } else {
                viewportwidth = document.getElementsByTagName('body')[0].clientWidth;
            }
        return viewportwidth;
    }

    return (
        <>
            <LayoutForm>
                <Label texto="Categoría" />
                <Select value={idCategoria} onChange={value => handleChange("idCategoria", value)} className="w-100 hyundai-select" loading={loadingM}>
                    {categorias && errorM === false && loadingM === false &&
                        categorias.map((categoria, i) =>
                            <Select.Option value={categoria.idCategoria} key={i}>{categoria.Nombre}</Select.Option>
                        )
                    }
                </Select>
            </LayoutForm>
            <LayoutForm>
                {isBus === false && states.formProducto?.idCategoria !== 4 ?
                    <>
                        <Label texto="Tipo vehículo" />
                        <Select onChange={value => handleChange("idSubcategoria", value)} value={idSubcategoria} className="w-100 hyundai-select" >
                            {subcategorias && errorS === false && loadingS === false &&
                                subcategorias.map((subcategoria, i) =>
                                    <Select.Option value={subcategoria.idCategoria} key={i}>{subcategoria.Nombre}</Select.Option>
                                )
                            }
                        </Select>
                    </>
                    :
                    <>
                        <Label texto="N° Pasajeros" />
                        <Select onChange={changePasajeros} value={filtro.NumeroDePasajerosValorMax} className="w-100 hyundai-select">
                            <Select.Option key={1} value={16}>Hasta 16 pasajeros</Select.Option>
                            <Select.Option key={2} value={33}>De 17 a 34 pasajeros</Select.Option>
                            <Select.Option key={3} value={45}>Más de 35 pasajeros</Select.Option>
                        </Select>
                    </>
                }
            </LayoutForm>

            <LayoutForm>
                <Label texto="Modelo" />
                <Select value={idModelo} onChange={value => handleChange("idModelo", value)} className="w-100 hyundai-select"  >
                    {modelos && modelos.length > 0 && errorMo === false && loadingMo === false &&
                        modelos.map((modelo, i) =>
                            <Select.Option value={modelo.idVehiculo} key={i}>{modelo.Nombre}</Select.Option>)
                    }
                </Select>
            </LayoutForm>

            {producto?.versiones && producto.versiones.length > 0 &&
                <LayoutForm>
                    <Label texto="Versión" />
                    <Select className="w-100 hyundai-select" onChange={handleChangeVersion} value={idVersion}>
                        {producto.versiones.map((modelo, i) =>
                            <Select.Option value={modelo.idVersion} key={i}>{modelo.Version}</Select.Option>)
                        }
                    </Select>
                </LayoutForm>
            }

            {/* <LayoutForm>
                <Label texto="Cantidad" />
                <button className="btn-unidad-ficha btn-restar" onClick={handleChangeRestar}>-</button>
                <Input className="input-unidad-hyundai" value={cantidad} readOnly />
                <button className="btn-unidad-ficha btn-sumar" onClick={handleChangeSumar}>+</button>
            </LayoutForm> */}

            {/* {
                !idModelo && getViewPortWidth() <= 768
                    ? <div className='h-div-sin-version' />
                    : <div className='h-div-con-version' />
            } */}

            {
                getViewPortWidth() <= 768 ? (
                    <div className='col-btn-formulario-cotizar'>
                        <Button
                            className="btn-primario-cotizador font-btn w-100 f-responsive mb-3"
                            onClick={handleContinue}
                        >
                            Siguiente
                        </Button>
                    </div>
                ) : (
                    <LayoutForm>
                        <Button className="btn-primario font-btn w-100 f-responsive mb-5" onClick={handleContinue}>Siguiente</Button>
                    </LayoutForm>
                )
            }
        </>
    );
}

export default Vehiculo;